import React from "react";

function ProfileStatusPro(props) {
  return (
    <div
      className={`card-tile ${
        window.location.pathname === "/user/profile-analytics"
          ? "border border-light"
          : "bg-light"
      }`}
      style={{ color: "#283270" }}
    >
      <p
        className={` ${
          window.location.pathname === "/user/profile-analytics"
            ? "text-light"
            : ""
        }`}
        style={{ fontSize: "14px", color: "#283270" }}
      >
        MY <strong>Profile Status</strong>
      </p>
      <div
        id="peerGroupperformanceone"
        className="justify-content-between equal-height-graph pt-4 prof-icon"
      >
        <div className="row text-center">
          <div className="col-6">
            <div className="row">
              <div className="icon col-6 mt-1">
                <img
                  src="\assets\images\profileStatus icons\agencyProIcon.png"
                  alt=""
                //   style={{ height: "auto", width: "80px" }}
                />
                <p
                  className={`${
                    window.location.pathname === "/user/profile-analytics"
                      ? "text-light"
                      : ""
                  } `}
                >
                  Agencies
                </p>
              </div>
              <div className="col-6">
                <div className="image-container mt-2">
                  <img
                    src="/assets/images/green_hexagon3px.png"
                    alt=""
                    className="img-fluid"
                  />
                  <div
                    className={`text-overlay ${
                      window.location.pathname === "/user/profile-analytics"
                        ? "text-light"
                        : ""
                    } `}
                  >
                    {props?.agencies}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="row">
              <div className="icon col-6">
                
                <img
                  src="\assets\images\profileStatus icons\companiesPro.png"
                  alt=""
                //   style={{ height: "auto", width: "80px" }}
                />
                <p
                  className={`${
                    window.location.pathname === "/user/profile-analytics"
                      ? "text-light"
                      : ""
                  } `}
                >
                  Companies
                </p>
              </div>
              <div className="col-6">
                <div class="image-container mt-2">
                  <img
                    src="/assets/images/green_hexagon3px.png"
                    alt=""
                    className="img-fluid"
                  />
                  <div
                    className={`text-overlay ${
                      window.location.pathname === "/user/profile-analytics"
                        ? "text-light"
                        : ""
                    } `}
                  >
                    {props?.companies}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row text-center mt-5">
          <div className="col-6">
            <div className="row">
              <div className="icon col-6">
                <img
                  src="\assets\images\profileStatus icons\organisationpro.png"
                  alt=""
                //   style={{ height: "80px", width: "auto" }}
                />
                <p
                  className={`org-text ${
                    window.location.pathname === "/user/profile-analytics"
                      ? "text-light"
                      : ""
                  }`}
                >
                  <span className="org-text-line-1" >Organisations</span>

                  {/* <span className="org-text-line-2">tions</span> */}
                </p>
              </div>
              <div className="col-6">
                <div class="image-container mt-2">
                  <img
                    src="/assets/images/green_hexagon3px.png"
                    alt=""
                    className="img-fluid"
                  />
                  <div
                    className={`text-overlay ${
                      window.location.pathname === "/user/profile-analytics"
                        ? "text-light"
                        : ""
                    } `}
                  >
                    {props?.organisations}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-6">
            <div className="row">
              <div className="icon col-6">
                <img
                  src="\assets\images\profileStatus icons\individualpro.png"
                  alt=""
                  className="individual"
                //   style={{ height: "auto", width: "80px" }}
                />

                {/* <img
                src={
                  window.location.pathname === "/user/profile-analytics"
                    ? "/assets/images/individualDashICon.png"
                    : "/assets/images/IndividualProIcon.png"
                }
                alt=""
              /> */}

                <p
                  className={`${
                    window.location.pathname === "/user/profile-analytics"
                      ? "text-light"
                      : ""
                  } `}
                >
                  Individuals
                </p>
              </div>
              <div className="col-6">
                <div class="image-container mt-2">
                  <img
                    src="/assets/images/green_hexagon3px.png"
                    alt=""
                    className="img-fluid"
                  />
                  <div
                    className={`text-overlay ${
                      window.location.pathname === "/user/profile-analytics"
                        ? "text-light"
                        : ""
                    } `}
                  >
                    {props?.individual}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProfileStatusPro;
